import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import AppRoutesO from './Router';
import {BrowserRouter} from 'react-router-dom' 
import * as serviceWorker from './serviceWorker';

ReactDOM.render(<BrowserRouter><AppRoutesO/></BrowserRouter>, document.getElementById('root'));


serviceWorker.unregister();
